import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const guardianTypesManagement = createApi({
    reducerPath: "guardianTypesManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        guardianTypesList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/guardian-types`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),

        addGuardianTypes: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/guardian-types`,
                method: "POST",
                body: body,
            }),
        }),

        deleteGuardianTypes: builder.mutation({
            query: (guardianTypesId) => ({
                url: `v1/${locale}/settings/guardian-types/${guardianTypesId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { 
    useGuardianTypesListMutation,
    useAddGuardianTypesMutation,
    useDeleteGuardianTypesMutation
} = guardianTypesManagement;
